import React from 'react';
import { Bus, Calendar, Building2, Users, DollarSign } from 'lucide-react';
import WhatsAppIcon from './icons/WhatsAppIcon';

const features = [
  {
    icon: Bus,
    title: 'أسطول حديث',
    description: 'باصات موديل 2027 راقية ومريحة، بمقاعد واسعة تجعل الطريق جزءاً ممتعاً من الرحلة.',
    color: 'bg-brown-500',
  },
  {
    icon: Calendar,
    title: 'مواعيد منتظمة',
    description: 'رحلات اقتصادية متاحة يومياً تقريباً، ورحلات VIP كل اثنين وخميس — اختر ما يناسب جدولك.',
    color: 'bg-navy-600',
  },
  {
    icon: Building2,
    title: 'سكن مضمون',
    description: 'فنادق 3 نجوم للباقة الاقتصادية و4-5 نجوم لباقة VIP، محجوزة ومؤكدة قبل انطلاقك.',
    color: 'bg-gold-500',
  },
  {
    icon: Users,
    title: 'خيارات للجميع',
    description: 'غرف خاصة للعائلات بسعة 4-5 أسرّة، وأسرّة في غرف مشتركة للعزاب بأسعار اقتصادية.',
    color: 'bg-purple-500',
  },
  {
    icon: DollarSign,
    title: 'أسعار واضحة',
    description: 'باقات شاملة النقل والسكن بدون رسوم خفية — كل التفاصيل تُوضح لك قبل تأكيد الحجز.',
    color: 'bg-rose-500',
  },
  {
    icon: WhatsAppIcon,
    title: 'تواصل مباشر',
    description: 'فريقنا يرد عليك عبر واتساب أو اتصال مباشر، من الاستفسار الأول حتى عودتك للرياض.',
    color: 'bg-teal-500',
  },
];

export default function WhyUs() {
  return (
    <section id="why-us" className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block bg-brown-100 text-brown-700 px-4 py-2 rounded-full text-sm font-cairo font-medium mb-4">
            لماذا نحن
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-amiri font-bold text-gray-900 mb-4">
            رحلتك الإيمانية تستحق الأفضل
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-gray-50 rounded-2xl p-8 hover:bg-white hover:shadow-xl transition-all duration-300 border border-transparent hover:border-gray-100 group"
              >
                <div className={`w-14 h-14 ${feature.color} rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform`}>
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-lg font-cairo font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 font-cairo text-sm leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
